import { createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("メールアドレスを変更")
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-gray-600 mb-2" }, "現在のメールアドレス", -1)
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" キャンセル ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 確定 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "sm",
    "is-overlay": true,
    onClose: _ctx.close
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.currentEmail), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "新しいメールアドレス",
          name: "newEmail",
          type: "email",
          placeholder: "例) new-email@example.com",
          value: _ctx.newEmail,
          invalid: !_ctx.validEmail,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newEmail = $event))
        }, null, 8, ["value", "invalid"]),
        (!_ctx.validEmail && _ctx.newEmail)
          ? (_openBlock(), _createBlock("p", _hoisted_6, " 有効なメールアドレスを入力してください "))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        color: "gray-400",
        "hover-color": "gray-500",
        outline: "",
        class: "mr-4",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validEmail || !_ctx.newEmail,
        onClick: _ctx.confirm
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}